import { useState } from "react";
import { CreditCard, MessageCircle } from "lucide-react";
import { STRIPE_PACK_CHECKOUT, STRIPE_RABIETAS_CHECKOUT, WA_PACK, WA_RABIETAS, PRICE, PRICE_RABIETAS, registerCheckoutLead, trackLead, errMsg } from "@/lib/api";
import { getActiveReferralCode, appendAffiliateCodeToWhatsApp } from "@/components/affiliate/AffiliateAttribution";
import { useCookieConsent } from "@/components/CookieConsentContext";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const fieldClass = "w-full rounded-lg border border-[var(--sand)] bg-[var(--cream)] px-4 py-3 outline-none focus:border-[var(--forest)]";

export default function CheckoutButton({ children, className, testId, productId = "equipo-calma" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { consent } = useCookieConsent();
  const affiliateReferral = getActiveReferralCode();
  const affiliateWhatsApp = Boolean(affiliateReferral);
  const productPrice = productId === "rabietas-2-3" ? PRICE_RABIETAS : PRICE;
  const affiliateWhatsAppUrl = productId === "rabietas-2-3" ? WA_RABIETAS : WA_PACK;
  const checkoutUrl = affiliateWhatsApp
    ? appendAffiliateCodeToWhatsApp(affiliateWhatsAppUrl)
    : productId === "rabietas-2-3" ? STRIPE_RABIETAS_CHECKOUT : STRIPE_PACK_CHECKOUT;
  const submit = async (event) => {
    event.preventDefault();
    if (!form.phone.trim()) {
      setError("Indica tu número de WhatsApp para poder enviarte el acceso.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await registerCheckoutLead({ ...form, product_id: productId });
      trackLead(consent, productId === "rabietas-2-3" ? "Rabietas: acompañar con límites" : "Equipo en Calma");
      window.location.assign(checkoutUrl);
    } catch (requestError) {
      setError(errMsg(requestError));
      setLoading(false);
    }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={testId} className={className}>
        {affiliateWhatsApp ? <MessageCircle size={20} /> : <CreditCard size={20} />} {children}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="border-[var(--sand)] bg-white text-[var(--ink)]">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Antes de continuar</DialogTitle>
            <DialogDescription className="text-[#5a4f46]">
              Indica tu número de WhatsApp para gestionar el acceso. El correo electrónico es opcional. {affiliateWhatsApp ? "Al continuar, guardaremos tu solicitud y abriremos WhatsApp para coordinar la compra." : "Al continuar, guardaremos tu solicitud y te llevaremos a Stripe para pagar con tarjeta. Cuando verifiquemos el pago, te enviaremos el acceso por correo electrónico."}
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <label className="block text-sm font-semibold">Nombre
              <input autoComplete="name" maxLength={120} required value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} className={`${fieldClass} mt-1 font-normal`} />
            </label>
            <label className="block text-sm font-semibold">Número de WhatsApp
              <input autoComplete="tel" type="tel" maxLength={30} required value={form.phone} onChange={(event) => setForm({ ...form, phone: event.target.value })} className={`${fieldClass} mt-1 font-normal`} />
            </label>
            <label className="block text-sm font-semibold">Correo electrónico
              <input autoComplete="email" type="email" maxLength={254} value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} className={`${fieldClass} mt-1 font-normal`} />
            </label>
            {error && <p role="alert" className="text-sm text-[#9b2c2c]">{error}</p>}
            <p className="text-xs text-[#7a6c5e]">Al continuar, guardaremos estos datos para gestionar tu solicitud y el acceso. Consulta la <Link to="/politica-de-privacidad" className="underline">política de privacidad</Link>.</p>
            <button type="submit" disabled={loading} className="btn-accent w-full">
              {loading ? "Guardando…" : affiliateWhatsApp ? "Continuar por WhatsApp" : `Continuar al pago · ${productPrice} €`}
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}